import { useMutation } from '@apollo/client';
import { CreateProductInput, CreateProductMutationVariables } from '_graphql/mutation/__generated__/graphql';
// import {
//   CreateProduct,
//   CreateProductVariables,
// } from '_graphql/mutation/__generated__/CreateProduct';
import { CREATE_PRODUCT } from '_graphql/mutation/products';
import { getProducts } from '_graphql/queries/products';

export const useCreateProduct = (variables?: CreateProductMutationVariables) => {
  const [productCreation, { ...rest }] = useMutation<
    CreateProductInput,
    CreateProductMutationVariables
  >(CREATE_PRODUCT, {
    variables,
    refetchQueries: ['GetProducts'],
  });
  return {
    ...rest,
    productCreation,
  };
};
